t = require('views/internal/teacup-with-helpers')('empty_list')

module.exports = t.renderable ({ classes, style, message }) ->
  t.p { class: 'empty-list ' + classes, style: style }, ->
    t.text message



// WEBPACK FOOTER //
// ./app/scripts/views/templates/empty_list.coffee